import { CollapsibleHeader } from '@/shared/components/GridTable/CollapsibleHeader/CollapsibleHeader'
import { GridColumnGroupingModel, GridColumnVisibilityModel } from '@mui/x-data-grid-premium'

export const columnGroupingModel: GridColumnGroupingModel = [
  {
    groupId: 'assignedTo',
    description: 'Assigned To',
    headerName: 'Assigned To',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['sequence', 'displayStopType', 'etaTime', 'timeAtStop', 'transitDistance', 'transitTime']}
        {...params}
      />
    },
    children: [
      { field: 'assignedTo' },
    ],
  },
  {
    groupId: 'orderDetails',
    description: 'Order Details',
    headerName: 'Order Details',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={[
          'orderNumber', 'preferredDateOfOperation', 'orderType', 'weight', 'volume', 'orderQuantity', 'timeWindow',
          'serviceTime', 'priority', 'maxOnboardTime', 'portalClientName', 'displayOrderAttributes',
          'tripNumber', 'consignmentNumber', 'description', 'deliveryInstruction', 'comments',
        ]}
        {...params}
      />
    },
    children: [
      { field: 'orderNumber' },
      { field: 'preferredDateOfOperation' },
      { field: 'orderType' },
      { field: 'weight' },
      { field: 'volume' },
      { field: 'orderQuantity' },
      { field: 'timeWindow' },
      { field: 'serviceTime' },
      { field: 'priority' },
      { field: 'maxOnboardTime' },
      { field: 'portalClientName' },
      { field: 'displayOrderAttributes' },
      { field: 'tripNumber' },
      { field: 'consignmentNumber' },
      { field: 'description' },
      { field: 'deliveryInstruction' },
      { field: 'comments' },
      { field: 'stopCompartment' },
    ],
  },
  {
    groupId: 'address',
    description: 'Address',
    headerName: 'Address',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['customerAddress', 'customerSuburb', 'customerState', 'customerPostcode', 'customerMapRef', 'customerAdditional']}
        {...params}
      />
    },
    children: [
      { field: 'customerAddress' },
      { field: 'customerSuburb' },
      { field: 'customerState' },
      { field: 'customerPostcode' },
      { field: 'customerMapRef' },
      { field: 'customerAdditional' },
    ],
  },
  {
    groupId: 'customer',
    description: 'Customer',
    headerName: 'Customer',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['customerNumber', 'customerName']}
        {...params}
      />
    },
    children: [
      { field: 'customerNumber' },
      { field: 'customerName' },
    ],
  },
  {
    groupId: 'depot',
    description: 'Depot',
    headerName: 'Depot',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['depotCode', 'depotName']}
        {...params}
      />
    },
    children: [
      { field: 'depotCode' },
      { field: 'depotName' },
    ],
  },
]

export type ColumnGroupingModelResults = {
  columnGroupingModel: GridColumnGroupingModel
  initialColumnGroupVisibility: GridColumnVisibilityModel
}

// TODO: column grouping models should be dependent on the column definitions retrieved from the server.
export const useInboxColumnGroupingModel = (): ColumnGroupingModelResults => {
  const initialColumnGroupVisibility: GridColumnVisibilityModel = {
    eta: true,
    orderDetails: true,
    addressDetails: true,
    customerDetails: true,
    depotDetails: true,
    runningTotals: true,
  }

  return {
    columnGroupingModel,
    initialColumnGroupVisibility,
  }
}